import React from "react"
import { Popover, PopoverProps } from "../Popover/Popover";
import Text from "../Text";
import classNames from "classnames";

import "./Tooltip.css"

type TooltipProps = {
  label: string | React.ReactNode;
  anchor?: PopoverProps["anchor"];
  origin?: PopoverProps["origin"];
  hidden?: boolean;
  classes?: {
    root?: string;
    content?: string;
    popover?: string;
  }
  children: React.ReactNode;
}

const baseClass = "wb-tooltip"

const Tooltip = ({
  label,
  anchor = "topCenter",
  origin = "bottomCenter",
  hidden = false,
  classes,
  children
}: TooltipProps) => {
  const ref = React.useRef(null)
  const [show, setShow] = React.useState<boolean>(false)

  const anchorEl = document.querySelector(`.${baseClass}`)
  return (
    <div className={classNames(`${baseClass}`, classes?.root)}>
      <Popover
        className={classNames(`${baseClass}--popover`, classes?.popover)}
        anchorEl={anchorEl}
        open={!hidden && show}
        close={() => setShow(false)}
        anchor={anchor}
        origin={origin}
        borderRadius="button"
        >
          <Text bodySmall>{label}</Text>
      </Popover>
      <div
        ref={ref}
        className={classNames(`${baseClass}--content`, classes?.content)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}>
        {children}
      </div>
    </div>
  )
}

export { Tooltip, TooltipProps }